import { z } from 'zod'

export const datasetsContextSearchSchema = z.object({
  page: z.coerce.number().int().min(0).optional(),
  size: z.coerce.number().int().positive().optional(),
  sortBy: z.string().optional(),
  nameSearch: z.string().optional(),
  quickFilter: z.enum(['Active', 'Inactive', 'Any']).optional()
})

export const datasetDetailSearchSchema = z.object({
  page: z.coerce.number().int().min(0).optional(),
  size: z.coerce.number().int().positive().optional(),
  sortBy: z.string().optional(),
  sortDirection: z.enum(['ASC', 'DESC']).optional(),
  search: z.string().optional(),
  quickFilter: z.enum(['Active', 'Inactive', 'Any']).optional(),
  edit: z.boolean().optional()
})
